import axios from "axios";
import { BACKEND_URL } from "../../../utils/api";

export interface ChatMessage {
  id: string;
  user_id: string;
  admin_id: string | null;
  admin_name: string | null;
  sender_type: "USER" | "ADMIN";
  message_type: "TEXT" | "IMAGE" | "VIDEO";
  content: string | null;
  file_url: string | null;
  file_size: number | null;
  is_read: boolean;
  created_at: string;
}

export interface ChatConversation {
  user_id: string;
  user_first_name: string | null;
  user_last_name: string | null;
  user_email: string | null;
  user_phonenumber: string | null;
  last_message: string | null;
  last_message_type: string | null;
  last_message_time: string | null;
  unread_count: number;
}

export const chatService = {
  async getConversations(
    token: string,
    skip: number = 0,
    limit: number = 200
  ): Promise<{ conversations: ChatConversation[]; total: number }> {
    const response = await axios.get(`${BACKEND_URL}/chat/conversations?skip=${skip}&limit=${limit}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data?.data;
  },

  async getMessages(
    token: string,
    userId: string,
    skip: number = 0,
    limit: number = 50
  ): Promise<{ messages: ChatMessage[]; total: number }> {
    const response = await axios.get(`${BACKEND_URL}/chat/messages/${userId}?skip=${skip}&limit=${limit}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data?.data;
  },

  async sendMessage(token: string, userId: string, content?: string, file?: File): Promise<ChatMessage> {
    const formData = new FormData();
    formData.append("user_id", userId);
    if (content) {
      formData.append("content", content);
    }
    if (file) {
      formData.append("file", file);
    }

    const response = await axios.post(`${BACKEND_URL}/chat/admin/send`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data?.data;
  },

  async markAsRead(token: string, userId: string): Promise<void> {
    await axios.put(
      `${BACKEND_URL}/chat/messages/read/${userId}`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
  },

  async getUnreadCount(token: string): Promise<number> {
    const response = await axios.get(`${BACKEND_URL}/chat/unread-count`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data?.data?.unread_count || 0;
  },
};
